module.exports = __webpack_public_path__ + "static/media/newsletter-march-2019-retreat.810f7c60.jpg";